import styled from 'styled-components'

export const ConversationTelemetryDataStyled = styled.pre`
  margin: ${(props) => props.theme.space.xsmall} 0 0;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: ${(props) => props.theme.typography.pxToRem(11)};
  color: ${(props) => props.theme.colors.text.tertiary};
`
